import React from 'react';
import './MenuBar.css';

const MenuBar = ({ onNavigate, isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const menuItems = [
    { label: 'Home', section: 'hero' },
    { label: 'About', section: 'about' },
    { label: 'Skills', section: 'skills' },
    { label: 'Experience', section: 'experience' },
    { label: 'Projects', section: 'projects' },
    { label: 'Education', section: 'education' },
    { label: 'Contact', section: 'contact' }
  ];

  const handleClick = (section) => {
    if (onNavigate) {
      onNavigate(section);
    }
  };

  return (
    <div className="menubar">
      <div className="menubar-left">
        <button 
          className="hamburger-menu"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2 4h16v2H2V4zm0 5h16v2H2V9zm0 5h16v2H2v-2z"/>
          </svg>
        </button>
        <div className="app-icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M14.5 1H1.5C0.67 1 0 1.67 0 2.5v11c0 0.83 0.67 1.5 1.5 1.5h13c0.83 0 1.5-0.67 1.5-1.5v-11c0-0.83-0.67-1.5-1.5-1.5zM8 11L4 7h8L8 11z"/>
          </svg>
        </div>
        <div className="menu-items-wrapper">
          {menuItems.map((menu) => (
            <div 
              key={menu.section}
              className="menu-item"
              onClick={() => handleClick(menu.section)}
            >
              <span className="menu-label">{menu.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="menubar-right">
      </div>
    </div>
  );
};

export default MenuBar;
